import { useCallback, useRef } from "react";
import { AppleButton } from "./AppleButton";
import { AuthRequest as AuthRequestManager } from "../../../AuthRequest";
import { event } from "../../../../../events/core/helpers";
import { ButtonPress } from "../../../../../events/event-types/common/ButtonPress";
import { EventSubCategories } from "../../../../../events/event-sub-categories";

export type Props = {
  onChangeState?: (
    state: `IDLE` | `IN_PROGRESS` | `CANCELLED` | `ERROR` | `SUCCESS`,
    errorMessage: string | null
  ) => any;
};

function Choose(props: Props) {
  const { onChangeState = () => {} } = props;

  const AuthRequest = useRef(new AuthRequestManager()).current;

  const signIn = useCallback(async () => {
    event(
      new ButtonPress({
        buttonName: `Sign in with Apple`,
        buttonSlug: `SIGN_IN_WITH_APPLE`,
        subCategory: EventSubCategories.AUTH,
      })
    );

    onChangeState(`IN_PROGRESS`, null);

    await AuthRequest.prompt({ provider: `apple` });
  }, [AuthRequest, onChangeState]);

  return (
    <div
      style={{
        width: `100%`,
      }}
    >
      <AppleButton onPress={signIn} />
    </div>
  );
}

export { Choose };
